'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

IfEnabledDirectiveController=function(){_createClass(IfEnabledDirectiveController,null,[{key:'$inject',get:function()
{
return['userService'];
}}]);

function IfEnabledDirectiveController(userService){var _this=this;_classCallCheck(this,IfEnabledDirectiveController);
this.isEnabled=tryGet(userService,'currentUser.enabledFeatures').
then(function(features){return features.includes(_this.feature)}).
otherwise(!1);
}return IfEnabledDirectiveController}();let


IfEnabledDirective=function(_BaseControllerBacked){_inherits(IfEnabledDirective,_BaseControllerBacked);function IfEnabledDirective(){_classCallCheck(this,IfEnabledDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}IfEnabledDirective.prototype.












factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.transclude=!0;
return directive;
};_createClass(IfEnabledDirective,[{key:'textBindings',get:function(){return['feature']}},{key:'template',get:function(){return'<ng-transclude ng-if="::controller.isEnabled"/>'}},{key:'controller',get:function(){return IfEnabledDirectiveController}}]);return IfEnabledDirective}(BaseControllerBackedDirective);


module.exports=IfEnabledDirective;
//# sourceMappingURL=ifEnabledDirective.js.map
